var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("TableCard", { staticClass: "evaluation-table" }, [
    _c("thead", { attrs: { slot: "thead" }, slot: "thead" }, [
      _c("tr", [
        _c(
          "th",
          {
            staticClass:
              "typography--body-3 typography--color-secondary typography--font-weight-500 evaluation-table-th"
          },
          [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("evaluations.table.number")) +
                "\n      "
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "th",
          {
            staticClass:
              "typography--body-3 typography--color-secondary typography--font-weight-500 evaluation-table-th"
          },
          [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("evaluations.table.student_name")) +
                "\n      "
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "th",
          {
            staticClass:
              "typography--body-3 typography--color-secondary typography--font-weight-500 evaluation-table-th"
          },
          [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("evaluations.table.comment")) +
                "\n      "
            )
          ]
        )
      ])
    ]),
    _vm._v(" "),
    _c(
      "tbody",
      { attrs: { slot: "tbody" }, slot: "tbody" },
      _vm._l(_vm.evaluationList, function(evaluation) {
        return _c("EvaluationTableRow", {
          key: evaluation.student_id,
          attrs: {
            evaluation: evaluation,
            "selected-domain-ids": _vm.selectedDomainIds
          }
        })
      }),
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-35a005f8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35a005f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/evaluations/components/EvaluationTable.vue
// module id = nztc
// module chunks = 1